import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DataTable from "./DataTable";
import { IColumnProps } from "../../../interfaces/tables";

import { IInterview } from "../../../interfaces/services";

interface IInterviewsTableProps {
    goBackRoute: string | null;
    linked: boolean;
    interviews: IInterview[];
    isLoading: boolean;
}

const InterviewsTable: FC<IInterviewsTableProps> = (props: IInterviewsTableProps) => {
    const { interviews, isLoading } = props;
    const navigate = useNavigate()
    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const columns: IColumnProps[] = [
        { name: "Interview Title", identifier: "interviewTitle" },
        { name: "Job Title", identifier: "jobTitle" },
        { name: "Date", identifier: "date" },
        { name: "Results", identifier: "results" },
        { name: "Reviewed by", identifier: "reviewedBy" },
    ];

    const interviewsList = interviews.map((interview, index) => ({
        id: interview.id,
        studentId: studentId,
        interviewTitle: interview.job_title || `Interview ${index + 1}`,
        jobTitle: interview.job_title,
        date: interview.created_at,
        results: interview.overall_score,
        reviewedBy: 'AI'
    }));

    return (
        <div className="immersion__student__resume__scanner__page_view">
            <DataTable
                columns={columns}
                list={interviewsList}
                isLoading={isLoading}
                titleIdentifier="interviewTitle"
                onTitleClick={(id) => navigate(`/students/${studentId}/interviews/${id}/details`)}
            />
        </div >
    );
};
export default InterviewsTable;